import { Inject, Injectable } from "@angular/core";
import { loadStripe } from "@stripe/stripe-js/pure";
import type { Stripe } from "@stripe/stripe-js";
import { IStripeService } from "./i-stripe.service";
import { IBillingRestClient } from "../../rest-clients/billing/i-billing-rest.client";
import { billingRestClientInjectionToken } from "../../rest-clients/billing/billing-rest-client-injection-token";

@Injectable()
export class StripeService implements IStripeService {
	private _stripe: Stripe | null = null;
	private _loadPromise: Promise<Stripe | null> | null = null;

	constructor(
		@Inject(billingRestClientInjectionToken) private readonly _billingRestClient: IBillingRestClient
	) {}

	public async getStripe(): Promise<Stripe | null> {
		if (this._stripe) return this._stripe;
		if (this._loadPromise) return this._loadPromise;

		this._loadPromise = this._initStripe();
		this._stripe = await this._loadPromise;
		return this._stripe;
	}

	private async _initStripe(): Promise<Stripe | null> {
		try {
			const config = await this._billingRestClient.getBillingConfig();

			if (!config?.publishableKey) {
				console.error("Stripe publishable key is missing from billing config");
				return null;
			}

			return loadStripe(config.publishableKey, {
				locale: "auto"
			});
		} catch (error) {
			console.error("Failed to initialize Stripe:", error);
			this._loadPromise = null;
			return null;
		}
	}
}
